import { z } from 'zod'

export const forgotPasswordValidation = z.object({
  username: z.string().min(1, { message: 'Username must not be blank' }),
})

export type ForgotPasswordValidation = z.infer<typeof forgotPasswordValidation>
